import type { Visualizer } from './types';
import { clearBg, drawHud } from './types';

/** Mirrored EQ with peak holds — closer to club/player bars feel. */
const peaks = new Float32Array(96);

export const barsViz: Visualizer = {
  id: 'bars',
  label: 'Equalizer Bars',
  draw(frame) {
    const { ctx, w, h, freq, bands } = frame;
    clearBg(ctx, w, h, 0.32 + bands.energy * 0.12);

    const n = Math.min(peaks.length, Math.floor(freq.length / 2));
    const gap = Math.max(1, w * 0.0015);
    const totalW = w * 0.88;
    const barW = totalW / n - gap;
    const baseY = h * 0.52;
    const maxH = h * 0.38;
    const x0 = (w - totalW) / 2;
    const decay = 0.04 + (1 - bands.energy) * 0.03;

    for (let i = 0; i < n; i++) {
      // log-ish bin pick
      const bin = Math.min(freq.length - 1, Math.floor(Math.pow(i / n, 1.35) * freq.length));
      const v = freq[bin] / 255;
      const target = v * maxH * (0.55 + bands.bass * 0.35 + bands.kick * 0.2);
      peaks[i] = Math.max(target, peaks[i] - maxH * decay);

      const bh = Math.max(3, target);
      const x = x0 + i * (barW + gap);

      const g = ctx.createLinearGradient(0, baseY - bh, 0, baseY + bh);
      g.addColorStop(0, `hsla(${165 + i * 1.4 + bands.highs * 35}, 92%, 64%, 0.95)`);
      g.addColorStop(0.5, `hsla(${185 + i * 0.8}, 85%, 48%, 0.75)`);
      g.addColorStop(1, `hsla(${200 + i * 0.5}, 80%, 40%, 0.35)`);
      ctx.fillStyle = g;
      // upper
      ctx.fillRect(x, baseY - bh, barW, bh);
      // mirror
      ctx.globalAlpha = 0.35;
      ctx.fillRect(x, baseY + 2, barW, bh * 0.85);
      ctx.globalAlpha = 1;

      // peak cap
      const py = baseY - peaks[i];
      ctx.fillStyle = `rgba(255,255,255,${0.55 + bands.beat * 0.35})`;
      ctx.fillRect(x, py - 2, barW, 2);
    }

    // center line glow
    const glow = ctx.createLinearGradient(0, baseY - 1, 0, baseY + 1);
    glow.addColorStop(0, `rgba(86,240,200,${0.15 + bands.energy * 0.25})`);
    glow.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = `rgba(86,240,200,${0.2 + bands.kick * 0.35})`;
    ctx.fillRect(x0, baseY, totalW, 2);

    if (bands.beat > 0.25) {
      ctx.fillStyle = `rgba(86,240,200,${0.04 * bands.beat})`;
      ctx.fillRect(0, 0, w, h);
    }
    drawHud(frame);
  },
};
